module.exports = __webpack_public_path__ + "static/img/12.1c5e705.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/12.png
// module id = bpHa
// module chunks = 0